module.exports = "publish-lights-red"